import { render } from "./StocklistView.vue?vue&type=template&id=2f3a6e5f"
import script from "./StocklistView.vue?vue&type=script&lang=js"
export * from "./StocklistView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__